import React from "react";
import { Box, Card, CardContent } from "@mui/material";

import KPTextform from "../../../components/KPTComponents/KPTextform";

import { textForm } from "../utils";
import MucDanhGiaC from "../DanhGia/MucC";

function MucC({ error, values, setValues, setPreview, thamDinhCode, mucPropsThamDinh }) {
  return (
    <Card id='muc_c' style={{ width: '100%', marginTop: 16 }}>
      <CardContent>
        <KPTextform
          component={Box}
          error={error}
          values={values}
          setValues={setValues}
          setPreview={setPreview}
          textForm={textForm.mucC}
        />
      </CardContent>
      {thamDinhCode && <MucDanhGiaC {...mucPropsThamDinh} />}
    </Card>
  )
}

export default MucC;
